import { PageLayout } from '@/common/layouts/PageLayout.tsx'
import React, { useEffect } from 'react'
import { useLazyGetPermissionsQuery, useLoginMutation } from '@/features/auth/auth.api.ts'
import { useLocation, useNavigate } from 'react-router'
import { cn } from '@/utils/style.ts'
import { Spin } from 'antd'
import { PageTitle } from '@/common/components/PageTitle.tsx'
import { AppEnv } from '@/utils/env.ts'

export const LoginPage: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [login, loginResult] = useLoginMutation()
  const [permissionsQuery, permissionsQueryResult] = useLazyGetPermissionsQuery()
  const isLoading = loginResult.isLoading || permissionsQueryResult.isLoading

  useEffect(() => {
    login({ envName: AppEnv.env })
  }, [login])

  useEffect(() => {
    if (loginResult && loginResult.isSuccess) {
      permissionsQuery()
    }
  }, [permissionsQuery, loginResult])

  useEffect(() => {
    if (loginResult.isSuccess && permissionsQueryResult.isSuccess) {
      navigate(location.state?.from || '/')
    }
  }, [loginResult.isSuccess, permissionsQueryResult.isSuccess, navigate, location.state?.from])

  useEffect(() => {
    if (loginResult.isError || permissionsQueryResult.isError) {
      throw new Error(loginResult.isError ? 'Failed to login.' : 'Failed to fetch permissions.')
    }
  }, [navigate, loginResult.isError, permissionsQueryResult.isError])

  return (
    <PageLayout className="h-full flex flex-col items-center justify-center">
      <PageTitle value="Login" />
      <div
        className={cn('flex flex-col items-center justify-center')}
      >
        <h1 className="text-3xl font-bold mb-4">Human Capital Portal</h1>
        <Spin size="large" spinning={isLoading} />
        <p className="text-xl">Verifying your credential</p>
      </div>
    </PageLayout>
  )
}